import React from 'react'
import PropTypes from 'prop-types'

import ReactHighlightWords from 'react-highlight-words'
import { colors } from '@PipelineDeals/shared-react-components'

const Highlighter = ({ term, children }) => {
  if (!term || term === '') return children

  const searchWords = term.split(' ')
  return (
    <ReactHighlightWords
      highlightClassName="SearchResultHighlight"
      searchWords={searchWords}
      autoEscape
      textToHighlight={children}
      highlightStyle={{
        background: colors.yellow[200]
      }}
    />
  )
}

Highlighter.propTypes = {
  children: PropTypes.string.isRequired,
  term: PropTypes.string
}

export { Highlighter as default }
